var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "s-bg-white rounded rounded-2 d-flex align-items-center list__item",
    on: {
      "click": function click($event) {
        return _vm.$router.push({
          name: 'LiffMemberCardPartnetPointShow',
          params: {
            partner_org_hashid: _vm.item.partner_org_hashid
          }
        });
      }
    }
  }, [_c('div', {
    staticClass: "list__image px-3"
  }, [_c('img', {
    attrs: {
      "src": require("@/pages/Liff/MemberCard/PartnetPoint/images/".concat(_vm.item.image)),
      "alt": ""
    }
  })]), _c('div', {
    staticClass: "flex-fill  px-3"
  }, [_c('div', {
    staticClass: "list__title mb-2"
  }, [_vm._v(_vm._s(_vm.item.title))]), _vm._l(_vm.item.exchange, function (j, jdx) {
    return _c('div', {
      key: jdx,
      staticClass: "s-text-xs mb-1 list__exchange"
    }, [_c('span', {
      staticClass: "s-text-primary font-weight-bold"
    }, [_vm._v(_vm._s(j.from.value))]), _vm._v(_vm._s(j.from.unit) + "→"), _c('span', {
      staticClass: "s-text-primary  font-weight-bold"
    }, [_vm._v(_vm._s(j.to.value))]), _vm._v(_vm._s(j.to.unit) + " ")]);
  }), _vm.item.more ? _c('div', {
    staticClass: "s-text-xs badge badge-secondary p-1"
  }, [_vm._v("更多方案")]) : _vm._e()], 2)]);
}
var staticRenderFns = []

export { render, staticRenderFns }